import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { OnboardingService } from '../../generated/auth/services/onboarding.service';
import * as OnboardingActions from './direct-onboarding.actions';
import { OnboardingLoadParams } from './direct-onboarding.model';
import { IOnboardingState } from './direct-onboarding.state';

@Injectable()
export class OnboardingEffects {
  private actions$ = inject(Actions);
  private onboardingService = inject(OnboardingService);
  private store = inject(Store<{ onboarding: IOnboardingState }>);

  constructor() {}

  loadOnboardings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OnboardingActions.loadOnboardings),
      withLatestFrom(this.store.select((state) => state.onboarding)),
      switchMap(([action, state]) => {
        const filters = state.filters;
        const params: OnboardingLoadParams = {
          ...filters,
          Page: action.params?.Page || filters.Page,
          PageSize: action.params?.PageSize || filters.PageSize,
        };

        // Clean undefined values from params
        const cleanParams: any = {};
        Object.keys(params).forEach((key) => {
          if (params[key as keyof OnboardingLoadParams] !== undefined) {
            cleanParams[key] = params[key as keyof OnboardingLoadParams];
          }
        });

        return this.onboardingService.onboardingProposalGetCreatorOnboardingsGet(cleanParams).pipe(
          map((response) =>
            OnboardingActions.loadOnboardingsSuccess({
              onboardings: response.result?.items || [],
              totalCount: response.result?.meta?.count || 0,
              currentPage: cleanParams.Page || 1,
            }),
          ),
          catchError((error) => of(OnboardingActions.loadOnboardingsFailure({ error: error.message }))),
        );
      }),
    ),
  );

  reloadOnFiltersChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        OnboardingActions.setFilter,
        OnboardingActions.resetFilter,
        OnboardingActions.updateFilter,
        OnboardingActions.updatePagination,
        OnboardingActions.setSorting,
      ),
      map(() => OnboardingActions.loadOnboardings({})),
    ),
  );
}
